import { financeExecutionModes, updateFinanceExecutionMode } from '@/services/finance.service'

export default {
	namespaced: true,
	state: {
		modeList: { data: [] },
		modeStatus: 'init',
		modeActionStatus: 'init',
	},
	getters: {
		getModeList: (state) => state.modeList,
		getModeStatus: (state) => state.modeStatus,
		getModeActionStatus: (state) => state.modeActionStatus,
	},
	mutations: {
		SET_MODE_LIST(state, val) {
			state.modeList = val
		},
		SET_MODE_STATUS(state, val) {
			state.modeStatus = val
		},
		SET_MODE_ACTION_STATUS(state, val) {
			state.modeActionStatus = val
		},
	},
	actions: {
		async fetchModes({ commit }) {
			commit('SET_MODE_STATUS', 'pending')
			try {
				const { data } = await financeExecutionModes()
				commit('SET_MODE_LIST', data)
				commit('SET_MODE_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_MODE_STATUS', 'init')
				throw error
			}
		},
		async toggleMode({ commit }, { vertical, executionMode }) {
			commit('SET_MODE_ACTION_STATUS', 'pending')
			try {
				const { data } = await updateFinanceExecutionMode(vertical, executionMode)
				commit('SET_MODE_ACTION_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_MODE_ACTION_STATUS', 'init')
				throw error
			}
		},
	},
}
